<template>
  <MainMobile>
    <template #before>
      <AppAlerts />
    </template>
    <template #footer>
      <AdvisorMobileTree />
    </template>
  </MainMobile>
</template>

<script setup lang="ts">
import { AppAlerts } from '@app'
import MainMobile from './Mobile/Mobile.vue'
import AdvisorMobileTree from './AdvisorMobileTree.vue'
</script>
